import { defineEvents, event, type PropsOf } from '@mathflat/data-tracking'

import type { EventPropertiesSchema } from './eventProperties.schema'

export const eventCatalog = defineEvents({
  GNB_로고_Click: event(),
  GNB_학습홈탭_Click: event(),
  GNB_챌린지탭_Click: event(),
  GNB_교재탭_Click: event(),
  GNB_학습지탭_Click: event(),
  GNB_의견남기기버튼_Click: event(),
  GNB_내정보버튼_Click: event(),
  GNB_사용가이드버튼_Click: event(),
  GNB_강의탭_Click: event(),
  GNB_더보기_Click: event(),

  학습홈_PV: event<EventPropertiesSchema.학습홈정보>(),
  학습홈_등급이올라간유형_Click: event(),
  학습홈_최고등급달성유형_Click: event(),
  학습홈_최고등급도전_Click: event(),
  학습홈_취약유형탈출_Click: event(),
  학습홈_소단원챌린지시작하기_Click: event(),
  학습홈_챌린지메뉴로이동_Click: event(),
  학습홈_학습지리스트탭_Click: event<EventPropertiesSchema.학습홈_학습지리스트탭>(),
  학습홈_리스트_학습지_Click: event<EventPropertiesSchema.학습홈_리스트_학습지>(),

  단원검색_Click: event(),
  단원검색모달오픈_Click: event(),
  단원검색하기버튼_Click: event<EventPropertiesSchema.단원검색어>(),
  단원검색어선택하기버튼_Click: event<EventPropertiesSchema.단원검색어>(),
  단원검색모달_닫기버튼_Click: event(),

  오늘의학습_오늘의학습시작하기버튼_Click: event<EventPropertiesSchema.최대연속학습수행일자>(),
  오늘의학습_이어서학습하기버튼_Click: event<EventPropertiesSchema.최대연속학습수행일자>(),
  오늘의학습_학습결과보기버튼_Click: event<EventPropertiesSchema.최대연속학습수행일자>(),
  오늘의학습_제출하기버튼_Click: event<EventPropertiesSchema.오늘의학습_정보>(),
  오늘의학습_최종제출하기버튼_Click: event<EventPropertiesSchema.오늘의학습_정보>(),
  오늘의학습_불꽃버튼_click: event<EventPropertiesSchema.오늘의학습_불꽃버튼>(),
  오늘의학습_캘린더버튼_click: event(),

  문풀동재생_Click: event<EventPropertiesSchema.요금제 & EventPropertiesSchema.문풀동>(),

  선생님설정챌린지_탭_Click: event(),
  단원유형별챌린지_탭_Click: event(),
  스마일바꾸기영역_유형칩_Click: event<EventPropertiesSchema.스마일바꾸기영역_유형칩>(),
  스마일바꾸기영역_다음_Click: event(),
  스마일바꾸기영역_이전_Click: event(),
  학습지풀기_시작하기_Click: event<EventPropertiesSchema.학습지_정보>(),
  학습지풀기_이어서학습하기_Click: event<EventPropertiesSchema.학습지_정보>(),
  챌린지_연산필터_Click: event<EventPropertiesSchema.연산필터적용여부>(),
  챌린지학습_시작하기_Click: event<EventPropertiesSchema.챌린지학습_정보>(),
  챌린지학습_이어서학습하기_Click: event<EventPropertiesSchema.챌린지학습_정보>(),

  학생앱_서술형학습지_제출모달_제출하기_Click: event<EventPropertiesSchema.서술형학습지_정보>(),
})

export type EventSchema = { [K in keyof typeof eventCatalog]: PropsOf<typeof eventCatalog, K> }
